/**
 * Client helper for submitting a quote/contact request.
 * Posts to the app's own server route, which saves the lead and sends
 * the confirmation + internal notification emails server-side.
 */
export async function submitQuoteRequest(
  payload: Record<string, unknown>,
): Promise<{ error: Error | null }> {
  try {
    const res = await fetch('/api/public/quote-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    if (!res.ok) {
      const data = await res.json().catch(() => ({}) as { error?: string })
      return { error: new Error((data as { error?: string }).error || 'Request failed') }
    }
    return { error: null }
  } catch (error) {
    return { error: error instanceof Error ? error : new Error('Request failed') }
  }
}
